import './index.scss';
import Info from '@/static/images/info.png';
import { Image, Button, ProgressBar } from 'react-bootstrap';
import DzPop from '@/components/dzPop';
import { useEffect, useMemo, useState } from 'react';
import FormInput from '@/components/formInput';
import { useRecord, useMintUserCopyright,useUserBalance } from '@/hooks';
import { numFormat } from '@/utils'

function Mint({ bookId }) {
    const [mintNum, setMintNum] = useState();
    const [mintPopShow, setMintPopShow] = useState(false);
    const [returnMinted, setReturnMinted] = useState({})
    const { record ,hasRecord,mintedDisabled,refreshRecord} = useRecord({ bookId });
    const mintUserCopyright = useMintUserCopyright()
    const {updateUserBalance} = useUserBalance()
    useEffect(() => {
        console.log('record:', record);
    }, [record]);
    const mintHandle = () => {
        setMintPopShow(true);
    }
    const closeMintPop = () => {
        setMintNum(null)
        setMintPopShow(false);
    }
    const confirm = async () => {
        // Handle confirmation logic here
        console.log("Mint confirmed", mintNum);
        const res = await mintUserCopyright(record['sbn'], '', mintNum, carbonSinkAmount)
        console.log('ressss:', res)
        if (res?.status) {
            const { UserMinted: {returnValues,transactionHash} } = res?.events ?? { UserMinted: {} }
            setReturnMinted({ sbn: record['sbn'],transactionHash, ...returnValues })
            refreshRecord();
            updateUserBalance();
            setMintPopShow(false);
            setCheckPopShow(true);
        }
    }

    const carbonSinkAmount = useMemo(() => {
        return record['carbonSinkPerCopy'] * mintNum * 1
    }, [mintNum])
    const [checkPopShow, setCheckPopShow] = useState(false);
    const closeCheckPop = () => {
        setCheckPopShow(false);
    }
    const checkOnPolygonscan = () => {
        // Handle check on polygonscan logic here
        console.log("Check on polygonscan");
        // setCheckPopShow(false);
        const url = `https://polygonscan.com/tx/${returnMinted['transactionHash']}`;
        window.open(url, '_blank');
    }
    const mintPercent = useMemo(() => {
        if(record['totalSupply']&&hasRecord){
            return (record['mintedCount'] / record['totalSupply'] * 100).toFixed(2)
        }
        return 0
    }, [record['mintedCount'], record['totalSupply']])
    return (
        <div className='mint-book-container'>
            <div className='mint-title'>
                Web3SBN Inscribe
                <Image src={Info} alt="info" width={20} className='info-icon' />
            </div>
            <div className='mint-content'>The agreement provides a Web3 standard book number for each e-book, and e-book holders receive a carbon sink when they are first minted.</div>
            <div className='mint-table'>
                <div className='mint-row'>
                    <div className='label'>Symbol</div>
                    <div className='value'><div className='ellipsis' title={record['sbn']||'$--'}>{record['sbn']||'$--'}</div></div>
                </div>
                <div className='mint-row'>
                    <div className='label'>Holders</div>
                    <div className='value'>{numFormat(record['mintedCount'])}</div>
                </div>
                <div className='mint-row'>
                    <div className='label'>Progress</div>
                    <div className='value'>
                        <div>{mintPercent}%</div>
                        {hasRecord?<ProgressBar className='mint-progress' variant="success" now={mintPercent} key={1} />:''}
                    </div>
                </div>
                <div className='mint-row'>
                    <div className='label'>Word Count</div>
                    <div className='value'>{numFormat(18384757)}</div>
                </div>
                <div className='mint-row'>
                    <div className='label'>Carbon Sink/Copy</div>
                    <div className='value'>{hasRecord?`${numFormat(record['carbonSinkPerCopy'])}g`:'— —'}</div>
                </div>
            </div>
            <div>
                {
                    hasRecord?
                        (mintedDisabled ? '' : <Button className="mint-btn" onClick={e => mintHandle()}>Mint</Button>)
                        : <Button className="mint-btn unreleased" >Unreleased</Button>

                }
            </div>
            <DzPop popShow={mintPopShow} closeClick={e => closeMintPop()} mask>
                <div className='mints-form'>
                    <div className='pop-title'> Mint Web3SBN inscriptions</div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Web3SBN</div>
                        <div className='text'><div className='ellipsis' title={record['sbn']}>{record['sbn']}</div></div>
                    </div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Total Supply</div>
                        <div className='text'>{numFormat(record['totalSupply'])}</div>
                    </div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Carbon Sink/Copy</div>
                        <div className='text'>{numFormat(record['carbonSinkPerCopy'])}g</div>
                    </div>
                    <div className='tips'>The quantity you obtained, it will be opened for trading soon</div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Amount</div>
                        <div className='text'>1</div>
                    </div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Limit Per Mint</div>
                        <div className='text'>{numFormat(record['limitPerMint'])}</div>
                    </div>
                    <FormInput className='mints-input' label={'Repeat Mint'} dark defaultValue={mintNum} placeholder={'Input the e-book quantityame'} onInput={e => setMintNum(e)} int max={record['limitPerMint']}></FormInput>
                    <div className='dash-row'></div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Service Fee</div>
                        <div className='text'>0</div>
                    </div>
                    <div className='mints-row flex-row dash-row'>
                        <div className='label'>Selling Price/Copy</div>
                        <div className='text'>{numFormat(record['sellingPrice'])} $16DAO</div>
                    </div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Total Price</div>
                        <div className='text'>{numFormat(mintNum * 1 * record['sellingPrice'])} $16DAO</div>
                    </div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Total Carbon Sink</div>
                        <div className='text'>{numFormat(carbonSinkAmount)}g</div>
                    </div>

                    <Button className='pop-btn' onClick={e => confirm()}>Confirm</Button>
                </div>
            </DzPop>
            <DzPop popShow={checkPopShow} closeClick={e => closeCheckPop()} mask>
                <div className='mints-form'>
                    <div className='pop-title'> Mint Web3SBN inscriptions</div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Web3SBN</div>
                        <div className='text'><div className='ellipsis' title={record['sbn']}>{record['sbn']}</div></div>
                    </div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Total Amount</div>
                        <div className='text'>{numFormat(returnMinted['amount'])}</div>
                    </div>
                    <div className='mints-row flex-row'>
                        <div className='label'>Total Carbon Sink</div>
                        <div className='text'>{numFormat(returnMinted['carbonSinkAmount'])}g</div>
                    </div>

                    <Button className='pop-btn' onClick={e => checkOnPolygonscan()}>Check on polygonscan</Button>
                </div>
            </DzPop>

        </div>
    )
}

export default Mint;